import type React from 'react';
import {
  ImageSelectionBox,
  type ImageSelectionBoxProps,
} from './ImageSelectionBox';
import { SelectedImage } from './SelectedImage';
import type { ImageDetails } from './types';

export interface ImageInputProps
  extends Pick<ImageSelectionBoxProps, 'state' | 'hoverable'> {
  value?: ImageDetails;
  metadata?: React.ReactNode;
  placeholder?: React.ReactNode;
  autoFocus?: boolean;
  disableFocus?: boolean;
  onFocus?: (e: React.FocusEvent<HTMLElement>) => void;
}

export const ImageInput = ({
  value,
  hoverable,
  state = 'idle',
  metadata,
  placeholder,
  autoFocus,
  disableFocus,
  onFocus,
}: ImageInputProps) =>
  value && state === 'idle' ? (
    <SelectedImage
      url={value.url}
      autoFocus={autoFocus}
      disableFocus={disableFocus}
      onFocus={onFocus}
    >
      {value.metadata?.name && (
        <SelectedImage.ImageName name={value.metadata.name} />
      )}
      {value.metadata && (
        <SelectedImage.ImageMetadata
          format={value.metadata.format}
          width={value.metadata.width}
          height={value.metadata.height}
        />
      )}
      {metadata}
    </SelectedImage>
  ) : (
    <ImageSelectionBox
      state={state}
      hoverable={hoverable}
      autoFocus={autoFocus}
      disableFocus={disableFocus}
      onFocus={onFocus}
    >
      {placeholder}
    </ImageSelectionBox>
  );
